import * as angular from "angular";
import {IController} from "angular";
import {PlanProjectEntity} from "../../models/plan-project-entity.model";


export class PlanningCreateProjectViewComponent implements IController {
  project: PlanProjectEntity;
  isShowPlanningTemplatesSelect: boolean;
  isCreateWithPreSelectedSteps: boolean;
  isDisableDraftTemplateSettings: boolean;
  onTemplateSelect: Function;
  onFromDateChange: Function;
  onFromTimeChange: Function;
  onToDateChange: Function;
  onToTimeChange: Function;
  onBranchesSelect: Function;

  public draftTemplate: any;

  isInvalidDates() {
    return this.project.from >= this.project.to ||
      this.project.to <= this.project.from;
  }

  onChangeTemplateDefaultDraft(id, draftTemplate) {
    this.project.draftTemplateId = id;
    this.project.useDraftTemplateSettings = !!draftTemplate?.settings;
    this.draftTemplate = draftTemplate;
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningCreateProjectView', {
    require: {
      form: '^form'
    },
    bindings: {
      project: '<',
      isShowPlanningTemplatesSelect: '<?',
      isCreateWithPreSelectedSteps: '<?',
      isDisableDraftTemplateSettings: '<?',
      onTemplateSelect: '&',
      onFromDateChange: '&',
      onFromTimeChange: '&',
      onToDateChange: '&',
      onToTimeChange: '&',
      onBranchesSelect: '&',
    },
    template: require('./planning-create-project-view.html').default,
    controller: PlanningCreateProjectViewComponent
  });

